import './styles/index.scss';
import './setup/datadog';

import { provideApolloClient } from '@vue/apollo-composable';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import apolloClient from '@/apollo/client';

import apolloProvider from './apollo/provider';
import App from './app/index.vue';
import { i18n } from './i18n';
import router from './router';
import components from './setup/base-components';
import directives from './setup/directives';
import addPlugins from './setup/plugins';

import './setup/polyfills';

const app = createApp(App);

const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(apolloProvider);
app.use(i18n);

provideApolloClient(apolloClient);

Object.keys(directives).forEach((key) => {
  app.directive(key, directives[key]);
});

components.forEach((component) => {
  app.component(component.name, component.config);
});

addPlugins(app);

app.mount('#app');
